import { useOrganizationEmailsQuery } from 'generated/graphql';
import { EmailItem } from './EmailItem';
import { SpinnerBlock } from 'components/SpinnerBlock';
import { css } from '@emotion/react';
import { theme } from 'styles/theme';

export const OrganizationEmails = () => {
	const [{ fetching, data }] = useOrganizationEmailsQuery();

	return (
		<>
			{fetching && <SpinnerBlock />}

			{!fetching && data && (
				<>
					<div
						css={css`
							display: flex;
							padding: 8px 0;
							gap: 8px;

							strong {
								font-weight: 600;
							}
						`}
					>
						<div
							css={css`
								width: 136px;
							`}
						>
							<strong>Type</strong>
						</div>
						<div>
							<strong>E-mail</strong>
						</div>
						<div></div>
					</div>
					<EmailItem newForm />

					<hr
						css={css`
							border: 0;
							border-top: 1px solid #f0f0ff;
						`}
					/>

					<div>
						{data.organizationEmails.length ? (
							<div>
								{data?.organizationEmails?.map((item, key) => {
									return <EmailItem item={item} key={key} />;
								})}
							</div>
						) : (
							<div
								css={css`
									text-align: center;
									padding: 40px 20px;
									color: ${theme.color.text[300]};
								`}
							>
								<div>
									<strong>Nastavte si notifikační e-maily.</strong>
								</div>
								<div>
									Notifikační emaily slouží k zasílání kopií/skrytých kopií, které jsou odesílány ze
									systému poptávajícím, či potvrzovacích emailů.
								</div>
							</div>
						)}
					</div>
				</>
			)}
		</>
	);
};
